import React from 'react';
import { connect } from 'react-redux';
import { saveStates, states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import {
  showSaveDataset,
  updateDataset,
  updateDatasetCancel,
  updataDatasetValidationErrors,
} from '../actions';
import datasetDiff, { validateDataset } from '../helper';
import { resolveCatalogueTemplate } from '../catalogue/helper';
import { datasetDirtyFlags, datasetIsDirty } from '../state/state';

const SaveDatasetAction = ({
  category,
  code,
  dataset,
  exitEdit,
  isEditing,
  isDirty,
  isNew,
  saveDataset,
  saveStatus,
  template,
  update,
  updateErrors,
}) => {
  const proceedToSave = (datasetToSave) => {
    const validationErrors = validateDataset(dataset, datasetToSave, template);
    updateErrors(category, code, validationErrors);

    return validationErrors.length === 0;
  };

  const submitForm = () => {
    const updates = datasetDiff(dataset);

    if (!updates) {
      exitEdit(category, code);
    } else if (proceedToSave(updates)) {
      update(category, code, updates, template);
    }
  };

  const onSaveClick = () => {
    if (!isNew) {
      submitForm();
    } else if (proceedToSave({ isNew: true, ...datasetDiff(dataset) })) {
      saveDataset(category, code, template);
    }
  };

  return (
    <RibbonMenu
      name="save"
      icon="save"
      disabled={!isEditing || !isDirty}
      message="actions.save"
      onClick={onSaveClick}
      className="aridhia-save-dataset-action"
      loading={isNew ? null : saveStatus === states.PENDING}
    />
  );
};

const mapStateToProps = ({
  datasets: {
    datasets,
  },
  catalogues: {
    templates,
  },
}, ownProps) => {
  const { dataset, template } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    copy: { catalogue: {} },
    isDirty: datasetDirtyFlags(),
    isNew: false,
    ...saveStates,
  });

  return {
    dataset,
    isDirty: datasetIsDirty(dataset),
    isNew: dataset.isNew,
    saveStatus: dataset.saveStatus,
    template,
  };
};

const mapDispatchToProps = {
  update: updateDataset,
  saveDataset: showSaveDataset,
  updateErrors: updataDatasetValidationErrors,
  exitEdit: updateDatasetCancel,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveDatasetAction);
